import { ChevronRight, ExpandMore } from '@mui/icons-material'
import { TreeItem, TreeView } from '@mui/lab'
import { Box } from '@mui/material'
import { Bin } from 'chezy-inventory-backend/bin/database/types/Bin'
import { useCallback, useEffect, useState } from 'react'

import { BinWithChildren, mkBinHeirarchy } from '../../utils/createBinTree'

type TreeViewRecursiveProps = { bins: BinWithChildren[] }
const TreeViewRecursive: (props: TreeViewRecursiveProps) => JSX.Element = (
  props: TreeViewRecursiveProps
): JSX.Element => {
  if (props.bins.length === 0) return <></>
  return (
    <>
      {props.bins.map((bin) => (
        <TreeItem nodeId={bin.id} label={bin.name} key={bin.id}>
          {(bin.children?.length ?? 0) > 0 ? <TreeViewRecursive bins={bin.children ?? []} /> : undefined}
        </TreeItem>
      ))}
    </>
  )
}

const BinBrowserSidebar = (props: {
  bins: Bin[]
  activeBinId?: string | undefined
  onSelect: (id: string | undefined) => void
}) => {
  const [tree, setTree] = useState<BinWithChildren[]>()

  useEffect(() => {
    setTree(mkBinHeirarchy(props.bins, undefined))
    setExpanded(['', ...(props.bins?.map((item) => item.id) ?? [])])
  }, [props.bins])

  const [expanded, setExpanded] = useState<string[]>([])

  const handleSelect = useCallback(
    (event: React.SyntheticEvent, nodeId: string[]) => {
      props.onSelect(nodeId as unknown as string)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.onSelect]
  )

  return (
    <Box>
      <TreeView
        aria-label="file system navigator"
        defaultCollapseIcon={<ExpandMore />}
        defaultExpandIcon={<ChevronRight />}
        defaultEndIcon={undefined}
        expanded={expanded}
        selected={[]}
        onNodeSelect={handleSelect}
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          paddingRight: '20px',
        }}
      >
        <TreeItem nodeId={''} label={'Chezy Bins'} onClick={() => props.onSelect(undefined)}>
          <TreeViewRecursive bins={tree ?? []} />
        </TreeItem>
      </TreeView>
    </Box>
  )
}

export { BinBrowserSidebar }
